import { http } from "../../../config/HttpMethod";
import { WellSurveyServerData } from "../../../store/model/calculations/calculation";


export const importWellSurveyData = async (inputData: FormData): Promise<any> => {
    try {
        const response = await http.post('/Determine/JetLift/Project/ImportSurveyData', inputData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Service error:', error);
        throw error;
    }
};

export const wellSurveyService = {
    // Get existing well survey data
    getExistingWellSurveyData: async (projectId: string): Promise<WellSurveyServerData[]> => {
        try {
            const response = await http.get(`Determine/JetLift/Project/GetWellSurveyInformation?projectId=${projectId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching well survey data:', error);
            throw error;
        }
    },

    // Clear well survey data
    clearWellSurveyData: async (projectId: string): Promise<void> => {
        try {
            await http.delete(`Determine/JetLift/Project/ClearSurveyData?projectId=${projectId}`);
        } catch (error) {
            console.error('Error clearing well survey data:', error);
            throw error;
        }
    },

    // Save well survey data and metadata
    saveWellSurveyData: async (payload: { projectId: string, wellSurveyMetadata: any, surveyData: any[] }): Promise<void> => {
        try {
            await http.post(`Determine/JetLift/Project/SaveWellSurveyData`, payload);
        } catch (error) {
            console.error('Error saving well survey data:', error);
            throw error;
        }
    },


}
